import { render, staticRenderFns } from "./Methodology.vue?vue&type=template&id=03a44081&scoped=true"
import script from "./Methodology.vue?vue&type=script&lang=js"
export * from "./Methodology.vue?vue&type=script&lang=js"
import style0 from "./Methodology.vue?vue&type=style&index=0&id=03a44081&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a44081",
  null
  
)

export default component.exports